export default function ReviewForm() {
  return (
    <div className="flex flex-col justify-center items-center w-md">
      <img src="/amy.svg" className="h-72 w-auto object-contain" />
    </div>
  );
}
